"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ToolTip = require("./ToolTip");
Object.keys(_ToolTip).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ToolTip[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ToolTip[key];
    }
  });
});